module.exports = __webpack_public_path__ + "0f396c3c218d12d8334e7ce005134587.pdf";